import { FC, CSSProperties } from "react";
import { Input } from "@src/lib/ui/Input";
import { cn } from "@src/lib/utils/cn";
import SearchIcon from "@src/lib/icons/18px/search";

type Props = {
  value: string;
  onChange: (value: string) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  placeholder?: string;
  className?: string;
  inputClassName?: string;
  /** Merged onto the leading search icon, e.g. the table toolbar's 14px size. */
  iconClassName?: string;
  onFocus?: () => void;
  style?: CSSProperties;
  autoFocus?: boolean;
};

const SearchBar: FC<Props> = (props: Props) => {
  const {
    value,
    onChange,
    onKeyDown,
    placeholder = "Search",
    className,
    inputClassName,
    iconClassName,
    onFocus,
    style,
    autoFocus,
  } = props;

  return (
    <div
      className={cn("min-w-0 flex-grow p-0 max-w-[500px]", className)}
      style={style}
    >
      <div className="relative">
        <SearchIcon
          className={cn(
            "absolute top-1/2 left-2.5 size-4 -translate-y-1/2 text-icon-tertiary",
            iconClassName,
          )}
        />
        <Input
          // A search box changes nothing: it stays typable while viewing as someone.
          data-impersonation-allow-input
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          aria-label={placeholder}
          onFocus={onFocus}
          autoFocus={autoFocus}
          onKeyDown={onKeyDown}
          inputClassName={cn("pl-8", inputClassName)}
        />
      </div>
    </div>
  );
};

export default SearchBar;
